import { render, staticRenderFns } from "./billForForPropety.vue?vue&type=template&id=39209c2c&scoped=true"
import script from "./billForForPropety.vue?vue&type=script&lang=js"
export * from "./billForForPropety.vue?vue&type=script&lang=js"
import style0 from "./billForForPropety.vue?vue&type=style&index=0&id=39209c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39209c2c",
  null
  
)

export default component.exports